import { IWeek } from '../types';
import { TimeHelper } from '../../../utils';

export const getWeekByDate = (unix: number, timezone: string): IWeek => {
  const startDate = TimeHelper.getStartOfWeek(unix, timezone);
  const endDate = TimeHelper.getEndOfWeek(unix, timezone);
  const weekKey = TimeHelper.toWeekOfYearStringFormat(startDate, timezone);
  const dateKeys: string[] = [];
  const unixDates: number[] = [];

  for (let offsetDays = 0; offsetDays < 7; offsetDays += 1) {
    const day = TimeHelper.addDaysTz(startDate, offsetDays, timezone);
    dateKeys.push(TimeHelper.unixToStandardFormat(day, timezone));
    unixDates.push(day);
  }

  return {
    weekKey,
    dateKeys,
    unixDates,
    startDate,
    endDate,
  };
};
